// wordpressから情報を取る取得する設定はこちらを見る
import wpService from '../../../services/wordpress.js'
// envのVUE_APP_WP_NEWS_CATEGORY = 0
// const NEWS_ID = process.env.VUE_APP_WP_NEWS_CATEGORY
// 10件表示
// const LIMIT = 10

export default {
  // エーシンクはアウェイトを待って実行されます。
  async getTopBanner({ commit }, limit) {

    // トライtopslide
    try {
      // ローディング状態をコミットする
      commit('SET_TOPBANNER_LOADING', true)
      // アウェイト（resにdataが入るのを待つ） カテゴリ ９ 内の投稿を 10件取得する
      const res = await wpService.getTopBannerInCategories(limit)
      // 取得したデータをvuexのストアへコミットする
      // console.log(res.data)
      commit('FETCH_TOPBANNER', res.data)
    // エラーキャッチしたら
    } catch (e) {
      // エラーを検知したら、空っぽのデータをコミットする
      commit('FETCH_TOPBANNER', [])
    }
    // ローディングをオフる
    commit('SET_TOPBANNER_LOADING', false)
  },
  async getTopBannerAll({ commit }) {

    // トライ
    try {
      // ローディング状態をコミットする
      commit('SET_TOPBANNER_LOADING', true)
      // アウェイト（resにdataが入るのを待つ） カテゴリ ９ 内の投稿を 100件取得する
      const res = await wpService.getTopBannerInCategories(10)
      console.log("topbanner",res)
      // 取得したデータをvuexのストアへコミットする
      // console.log(res.data)
      commit('FETCH_TOPBANNER_ALL', res.data)
    // エラーキャッチしたら
    } catch (e) {
      // エラーを検知したら、空っぽのデータをコミットする
      commit('FETCH_TOPBANNER_ALL', [])
    }
    // ローディングをオフる
    commit('SET_TOPBANNER_LOADING', false)
  },
  // エーシンクはアウェイトを待って実行されます。
  async getTopBannerDetail({ commit }, id) {
    // トライ
    try {
      // ローディング状態をコミットする
      commit('SET_TOPBANNER_DETAIL_LOADING', true)
      // IDに対応した投稿をゲットする、resに入れる
      const res = await wpService.getTopBannerpById(id)
      // 取得したデータをvuexのストアで
      commit('SET_TOPBANNER_DETAIL', res.data)
    // エラーをキャッチしたら
    } catch (e) {
      //console.log(e)
      // NULLをコミットする
      commit('SET_TOPBANNER_DETAIL', null)
    }
    // ローディングをオフる
    commit('SET_TOPBANNER_DETAIL_LOADING', false)
  },
  // clearDetail({ commit }, empty){
  //   commit('SET_STREAMER_DETAIL', empty)
  // }
}
